import { Link } from "react-router-dom";
import logo from "../images/logo.png";

export const Navi = () => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <Link className="navbar-brand" to="/">
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "40px",
                marginTop: "-10px",
              }}
            />
          </Link>
        </div>
      </div>
    </nav>
  );
};
